import { localToday } from "@/utils/date";
// Filter fields only. Non-filter UI state (notification panel) lives outside
// initialState so "Clear all filters" / RESET_FILTERS never disturbs it.
const initialState = () => ({
  page: 1,
  collection_status: "Overdue",
  selected_tab: 0,

  executive_type: "",
  executive_name: "",
  agent_assigned: [], // multi-select -- the COLLECTION executive
  // The two executives who handled the file before collection got it. Separate
  // from agent_assigned: a row has all three, and they are different people.
  lead_executive: [], // multi-select
  los_executive: [], // multi-select
  product_type: [], // multi-select
  loan_type: [], // multi-select (Fresh Loan / Reloan / Reapplied Loan)
  payment_status: [], // multi-select
  settlement_status: [], // multi-select
  feedback_status: "",

  date_menu: false,
  // Two independent due-date filters: Due Date (from-to) and Due Till (on or
  // before that day).
  daterange: [],
  display_daterange: null,
  due_till: null,
  display_due_till: null,
  agreement_date_menu: false,
  agreement_daterange: [],
  display_agreement_daterange: null,
  disbursement_daterange: [],
  display_disbursement_daterange: null,
  fd_display_date: null,
  follow_up_date: null,
  call_tag: [], // multi-select: tag names, rows with ANY of them
  date_bucket_id: null,
  overdue_days: [],
  upcoming_days: null,
  today: localToday(),

  current_city: [], // multi-select
  case_tag: "",
  // "true" -> only blacklisted customers, "false" -> only everyone else,
  // "" -> no filtering. A blacklisted customer's existing loan still shows in
  // Collections; the block is on new applications only.
  blacklisted: "",
  state_filter: [], // multi-select
  pincode: [], // multi-select (Special Filters)
  employment_type: [], // multi-select (Special Filters): Salaried / Self Employed
  bank_name: [], // multi-select (Special Filters): backend bank keys
  salary_range: [], // DPD-style buckets (Special Filters): ["15001 - 17500", "100001+"]
  loan_tenure: [], // DPD-style buckets (Special Filters): month ranges, ["0 - 3", "60+"]
  age_range: [], // DPD-style buckets (Special Filters): ["21 - 25", "61+"]
  dealer_id: [], // multi-select
  company_name: "",
  // Borrower Company: the borrower's employer, typed free-hand
  employer_name: "",
});

export default {
  namespaced: true,
  state: {
    ...initialState(),

    notification_panel_dialog: {
      flag: false,
      lead_creation: "",
      type: "",
    },
    notification_panel_stepper_id: 1,
  },

  mutations: {
    RESET_FILTERS(state) {
      // Only filter fields are reset; notification panel state is preserved.
      Object.assign(state, initialState());
    },
    SET_NOTIFICATION_PANEL_STEPPER_ID( state, payload){
     state.notification_panel_stepper_id = payload;
    },
    SET_NOTIFICATION_PANEL_DIALOG( state, {flag, lead_creation, type}){
     state.notification_panel_dialog.flag = flag;
     state.notification_panel_dialog.lead_creation = lead_creation;
     state.notification_panel_dialog.type = type;
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
    setNotificationPanelStepperId({ commit }, payload){
      commit("SET_NOTIFICATION_PANEL_STEPPER_ID", payload);
    },
    setNotificationPanelDialog({ commit }, payload){
      commit("SET_NOTIFICATION_PANEL_DIALOG", payload);
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
    getNotificationPanelStepperId:(state) => {
      return state.notification_panel_stepper_id;
    },
    getNotificationPanelDialog:(state) => {
      return state.notification_panel_dialog;
    },
  },
};
